export default {
    PENDING_SESSION_LOGIN: 'PENDING_SESSION_LOGIN',
    SUCCESS_SESSION_LOGIN: 'SUCCESS_SESSION_LOGIN',
    FAILURE_SESSION_LOGIN: 'FAILURE_SESSION_LOGIN',
    RESET_SESSION_LOGIN: 'RESET_SESSION_LOGIN'
}
